import { RatecardVersion } from '@app/features/scope-overview/model/ratecard-version.model'
import { Observable } from 'rxjs'

export interface UploadModalConfig {
  title: string
  titleBody?: string
  body?: string
  type: UploadType
  submitFn: (file: File) => Observable<any>
  successFn: (result: any) => void
  showRemoveOption?: boolean
  removeOptionText?: string
  removeFn?: () => void
  showBody?: boolean
  ratecards?: RatecardVersion[]
  rateCards$?: Observable<RatecardVersion[]>
  verifyService?: any
  includeRoleAndHour?: boolean
}

export enum UploadType {
  WORD_OUTPUT = 'word_output',
  EXCEL_OUTPUT = 'excel_output',
  CLIENTS = 'clients',
  LOCATION = 'location',
  CONTACT = 'contact',
  BRAND = 'brand',
  RATECARD = 'ratecard',
  DELIVERABLE = 'deliverable',
  DELIVERABLE_WITH_COMPONENTS = 'deliverable-with-components',
  COMPONENT = 'component',
  FIXED_FEE_COMPONENT = 'fixed-fee-component',
  FIXED_FEE_DELIVERABLE = 'fixed-fee-deliverable',
  TASK = 'task',
  SCENARIO = 'scenario',
}
